import React, { useState } from 'react';
import { useFormikContext } from 'formik';

import Button, { ButtonType } from 'legacy/common/components/button/Button';

import { GoToStepFn, StepsId } from '../types';
import OrgsOnlyAccess from './OrgsOnlyAccess';
import AssociationsOnlyAccess from './AssociationsOnlyAccess';
import MemberOnlyTabButton from './MemberOnlyTabButton';
import { FormValueDto } from '../helpers/computeInitialValues';

const MAX_SELECTION = 10;

type Props = {
  goToStep: GoToStepFn;
};

enum Tabs {
  Orgs = 'Orgs',
  Associations = 'Associations'
}

const MemberOnlyAccess = ({ goToStep }: Props) => {
  const { values, setFieldValue } = useFormikContext<FormValueDto>();
  const [selectedTab, setSelectedTab] = useState(Tabs.Orgs);
  const [selectedOrgs, setSelectedOrgs] = useState<string[]>(
    values?.purchaseRequirements?.requiredOrganizationIds || []
  );
  const [selectedAssociations, setSelectedAssociations] = useState<string[]>(
    values?.purchaseRequirements?.requiredAssociationIds || []
  );

  const totalSelected = selectedOrgs.length + selectedAssociations.length;
  const isSelectionDisabled = totalSelected >= MAX_SELECTION;

  const handleSubmit = () => {
    setFieldValue('purchaseRequirements.requiredOrganizationIds', selectedOrgs);
    setFieldValue(
      'purchaseRequirements.requiredAssociationIds',
      selectedAssociations
    );
    goToStep(StepsId.Main);
  };

  const setActiveTab = (tab: Tabs) => setSelectedTab(tab);

  return (
    <>
      <div className="flex flex-1 justify-center pt-3 pb-1 gap-3">
        <MemberOnlyTabButton
          tabId={Tabs.Orgs}
          onClick={setActiveTab}
          selectedTab={selectedTab}
        >
          Organizations
        </MemberOnlyTabButton>
        <MemberOnlyTabButton
          tabId={Tabs.Associations}
          onClick={setActiveTab}
          selectedTab={selectedTab}
        >
          Associations
        </MemberOnlyTabButton>
      </div>
      {selectedTab === Tabs.Orgs ? (
        <OrgsOnlyAccess
          selectedOrgs={selectedOrgs}
          setSelectedOrgs={setSelectedOrgs}
          isSelectionDisabled={isSelectionDisabled}
        />
      ) : (
        <AssociationsOnlyAccess
          selectedAssociations={selectedAssociations}
          isSelectionDisabled={isSelectionDisabled}
          setSelectedAssociations={setSelectedAssociations}
        />
      )}
      <div className="flex justify-center fixed w-full left-0 bottom-0 bg-white pb-8 z-50 md:pb-4 border-t-1 px-4 py-4 shadow-primary-50 shadow-top md:shadow-none">
        <div className="w-full max-w-[343px]">
          <Button
            className="w-full bg-[#3853C4]! text-white"
            type={ButtonType.Primary}
            onClick={handleSubmit}
            disabled={totalSelected > MAX_SELECTION}
          >
            Save Selection • {`${totalSelected}/${MAX_SELECTION}`}
          </Button>
        </div>
      </div>
    </>
  );
};

export default MemberOnlyAccess;
